module.exports = __webpack_public_path__ + "images/emoji/spades.e17aca598f0241658bd4.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/spades.png
// module id = YME+
// module chunks = 24